export const routesRaporProjeSaat = [
  {
    path: "/rapor_projesaat",
    name: "rapor_projesaat",
    component: () => import("@/views/mesai/rapor_projesaat/index.vue"),
    meta: {
      public: false,
      title: "mesai.Proje Saat Rapor",
      yetki: { k: [1012902] },
    },
  },
]
